import React, { FC, useCallback, useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { wrap } from 'popmotion'
import { HStack, Stack } from '@chakra-ui/react'

import { BasicComponentProps } from '../../common/types'

const variants = {
  enter: (x: number) => {
    return {
      x: x - 100,
      opacity: 0,
    }
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
  exit: (x: number) => {
    return {
      zIndex: 0,
      x: -x,
      opacity: 0,
      display: 'none',
    }
  },
}

type SliderOwnProps = {
  titles: string[]
  x?: number
  ms?: number
}

const Slider: FC<BasicComponentProps<SliderOwnProps>> = ({
  titles,
  x = 300,
  ms = 1700,
  ...rest
}) => {
  const [page, setPage] = useState(0)

  const paginate = useCallback(
    (newPage: number) => {
      setPage((prevPage) => prevPage + newPage)
    },
    [page]
  )

  const index = wrap(0, titles.length, page)

  useEffect(() => {
    const interval = setInterval(() => {
      paginate(1)
    }, ms)
    return () => clearInterval(interval)
  }, [])

  return (
    <Stack>
      <HStack wrap='nowrap' width={x} overflow='hidden' {...rest}>
        <AnimatePresence custom={x}>
          <motion.span
            key={page}
            variants={variants}
            custom={x}
            initial='enter'
            animate='center'
            exit='exit'
            transition={{
              x: { type: 'spring', stiffness: 50, damping: 30 },
              opacity: { duration: 0.3 },
            }}
            style={{ width: '100%' }}
          >
            {titles[index]}
          </motion.span>
        </AnimatePresence>
      </HStack>
      <motion.div
        initial={{
          background:
            'linear-gradient(94.43deg, #B70646 -18.98%, #17191B 113.48%)',
        }}
        animate={{
          background:
            'linear-gradient(94.43deg, #17191B -18.98%, #B70646 113.48%)',
        }}
        transition={{
          duration: 2,
          ease: 'easeInOut',
          repeat: Infinity,
          repeatType: 'reverse',
          repeatDelay: 1,
          mass: 5,
        }}
        style={{
          width: x,
          height: 3,
          borderRadius: 2,
          filter: 'brightness(0.9)',
        }}
      />
    </Stack>
  )
}

export default Slider
